import React from "react"
import { useRestoreConsent } from "../hooks/useRestoreConsent"

const RestoreConsent = () => {
  useRestoreConsent()
  return null // This component only runs the hook
}

export default RestoreConsent
